import React, { useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Device } from '../../../../../../../types/Device';
import { CameraTile } from '../CameraTile/CameraTile';
import DeleteDeviceModal from '../modals/DeleteDeviceModal/DeleteDeviceModal';
import { useSelectedLayout } from '../../../../../../../store/useSelectedLayout';
import { message } from 'antd';
import { useIsLayoutFormChanged } from '../../api/layout/useIsLayoutFormChanged';
import { takePhotos } from '../../api/recording/recordingApi';

interface SortableCameraTileProps {
    id: string;
    device?: Device;
    index: number;
    x: number;
    y: number;
    width: number;
    height: number;
    cols: number;
    rows: number;
    setIsModalVisible: (open: boolean) => void;
    setSelectedDevice?: () => void;
    onAddDevice: () => void;
}

const SortableCameraTile: React.FC<SortableCameraTileProps> = ({
    id,
    device,
    index,
    x,
    y,
    width,
    height,
    setIsModalVisible,
    setSelectedDevice,
    onAddDevice,
}) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id,
    });
    const [deleteDeviceModal, setDeleteDeviceModal] = useState(false);
    const { selectedLayout, setSelectedLayout } = useSelectedLayout();

    const { layoutViewType, setLayoutViewType, setPendingChanges } = useIsLayoutFormChanged();

    const style: React.CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        gridColumn: `${x + 1} / span ${width}`,
        gridRow: `${y + 1} / span ${height}`,
        zIndex: isDragging ? 1000 : 1,
        position: 'relative',
        // touchAction: 'none' // Важно для мобильных устройств
    };

    const handleDeleteDevice = async () => {
        if (!selectedLayout || !device) return;

        // Фильтруем устройства, оставляем все кроме удаляемого
        const updatedDevices = selectedLayout?.devices?.filter((d: any) => d.UID !== device.UID);

        // Сохраняем изменения в промежуточное состояние
        setPendingChanges({
            devices: updatedDevices,
            viewType: layoutViewType, // сохраняем текущий тип раскладки
        });

        // Локально обновляем отображение
        setSelectedLayout({
            ...selectedLayout,
            devices: updatedDevices,
        });

        message.success('Устройство удалено из раскладки (изменения не сохранены)');
    };
    // console.log('onAddDevice in SortableCameraTile:', onAddDevice);
    return (
        <div ref={setNodeRef} style={style} {...attributes}>
            <CameraTile
                device={device}
                index={index}
                onMenuClick={() => {}}
                onAddDevice={onAddDevice}
                menuType="edit"
                isShowNameDevice={true}
                setIsModalVisible={setIsModalVisible}
                style={{ height: '100%', width: '100%' }}
                dragListeners={listeners}
                isDragging={isDragging}
                setSelectedDevice={setSelectedDevice}
                setDeleteDeviceModal={setDeleteDeviceModal}
                drag
            />
            <DeleteDeviceModal
                onCancel={() => setDeleteDeviceModal(false)}
                onOk={() => handleDeleteDevice()}
                visible={deleteDeviceModal}
                device={device!}
            />
        </div>
    );
};

export default SortableCameraTile;
